module.exports = __webpack_public_path__ + "img/avatar_2.e163dd3e.jpg";